import { render, staticRenderFns } from "./startPlaceholder-editor.vue?vue&type=template&id=10c0a37e&scoped=true&"
import script from "./startPlaceholder-editor.vue?vue&type=script&lang=js&"
export * from "./startPlaceholder-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c0a37e",
  null
  
)

export default component.exports